/**
 * Shown for addresses that match no page, and for unexpected errors while rendering a page.
 */

import { CircleAlert, Compass } from "lucide-react";
import { isRouteErrorResponse, Link, useRouteError } from "react-router";

import { MessagePage, styles } from "../components/ui.js";

export function NotFound() {
  return (
    <MessagePage
      icon={Compass}
      title="Page not found"
      actions={
        <>
          <Link to="/" className={styles.primaryButton}>
            Back to the home page
          </Link>
          <Link to="/campaigns" className={styles.secondaryButton}>
            See the campaigns
          </Link>
        </>
      }
    >
      <p>The page you are looking for does not exist or has moved.</p>
    </MessagePage>
  );
}

/** Router error element: a missing page (404) or an error thrown while rendering. */
export function RouteError() {
  const error = useRouteError();
  if (isRouteErrorResponse(error) && error.status === 404) {
    return <NotFound />;
  }
  return (
    <MessagePage
      icon={CircleAlert}
      title="Something went wrong"
      actions={
        <Link to="/" className={styles.primaryButton}>
          Back to the home page
        </Link>
      }
    >
      <p>This page could not be shown. Please try again.</p>
    </MessagePage>
  );
}
